
import { useEffect } from "react";
import { createContext,useContext,useState } from "react";


type ModalsContextInterface = {
    isCreateEntryModalOpen: boolean,
    setIsCreateEntryModalOpen: (isOpen: boolean) => void,

}

const ModalsStateContext = createContext<ModalsContextInterface>({
    isCreateEntryModalOpen: false,
    setIsCreateEntryModalOpen: () => {},
});




export function ModalsStateProvider({ children }: { children: React.ReactNode }) {

        const [isCreateEntryModalOpen, setIsCreateEntryModalOpen] = useState(localStorage.getItem("isCreateEntryModalOpen") == "true");    
        const state = {
            isCreateEntryModalOpen,
            setIsCreateEntryModalOpen,
        };

        useEffect(()=>{
            if(isCreateEntryModalOpen!==null && isCreateEntryModalOpen!==undefined){
                localStorage.setItem("isCreateEntryModalOpen",isCreateEntryModalOpen.toString());
            }
        },[isCreateEntryModalOpen]);


    return (
        <ModalsStateContext.Provider value={state}>


            {children}
        </ModalsStateContext.Provider>
    );
}

export function useModalStateContext() {return useContext(ModalsStateContext);};
